import { Star } from 'lucide-react'

export const StarRating = ({
  rating,
  size = 5,
}: {
  rating: number
  size?: number
}) => (
  <div className='flex items-center'>
    {[...Array(5)].map((_, i) => (
      <Star
        key={i}
        className={`text-yellow-400 ${
          i < rating ? 'fill-current' : 'fill-transparent'
        }`}
        size={size * 4}
        strokeWidth={1.5}
      />
    ))}
  </div>
)
